import axios from "axios";
import { Notification, MessageBox, Message, Loading } from "element-ui";
import store from "@/store";
import { getToken, platform } from "@/utils/auth";
import { tansParams, blobValidate } from "@/utils/ruoyi";
import cache from "./cache";
import { jiuRuiApi } from "./config";
import { post, asyncPost, get, asyncGet } from "@/utils/requestDecorators";
import Cookies from "js-cookie";

export const errorCode = {
  401: "认证失败，无法访问系统资源",
  403: "当前操作没有权限",
  404: "访问资源不存在",
  default: "系统未知错误，请反馈给管理员",
};
let loadingInstance = null;
let loadingState = false;
let loadingTimer = null;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers["platform"] = "custom";

//创建axios实例
const service = axios.create({
  baseURL:jiuRuiApi, // api的base_url
  timeout: 100000, // 请求超时设置
});

// 请求拦截
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    // if (getToken() && !isToken) {
    //   config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    // }

    // if (config.header) {
    //   //移动端阅读webview传递token的骚操作
    //   if (config.header.token) {
    //     //移动端阅读webview传递token的骚操作
    //     config.headers["Authorization"] =
    //       "Bearer " + localStorage.getItem("token");
    //   }
    // }
    //平台代号
    config.headers["platform"] = platform;
    config.headers["deviceType"] = 0;
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === "post" || config.method === "put")
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === "object"
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const sessionObj = cache.session.getJSON("sessionObj");
      if (
        sessionObj === undefined ||
        sessionObj === null ||
        sessionObj === ""
      ) {
        cache.session.setJSON("sessionObj", requestObj);
      } else {
        const s_url = sessionObj.url; // 请求地址
        const s_data = sessionObj.data; // 请求数据
        const s_time = sessionObj.time; // 请求时间
        const interval = 2000; // 间隔时间(ms)，小于此时间视为重复提交
        // 如果不是无需显示loading的接口
        if (!apiList.includes(sessionObj.url)) {
          // 请求1500毫秒后没有响应显示loading
          loadingTimer = setTimeout(() => {
            if (!loadingState) {
              loadingState = true;
              loadingInstance = Loading.service({ fullscreen: true });
            }
          }, 1500);
        }
        if (
          s_data === requestObj.data &&
          requestObj.time - s_time < interval &&
          s_url === requestObj.url
        ) {
          const message = "数据正在处理，请勿重复提交";
          console.warn(`[${s_url}]: ` + message);
          return Promise.reject(new Error(message));
        } else {
          cache.session.setJSON("sessionObj", requestObj);
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 响应成功关闭loading
    clearTimeout(loadingTimer);
    if (loadingState) {
      loadingState = false;
      loadingInstance.close();
    }
    // 未设置状态码则默认成功状态
    // console.log(res);
    const config = res.config || {};
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }
    if (code === 401) {
      // if (!isRelogin.show) {
      //   isRelogin.show = true;
      //   MessageBox.confirm(
      //     "登录状态已过期，您可以继续留在该页面，或者重新登录",
      //     "系统提示",
      //     {
      //       confirmButtonText: "重新登录",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //     }
      //   )
      //     .then(() => {
      //       isRelogin.show = false;
      //       if (store.getters.userId) {
      //         store.dispatch("FedLogOut").then(() => {
      //           location.href = "/#/login";
      //         });
      //       } else {
      //         location.href = "/#/login";
      //       }
      //     })
      //     .catch(() => {
      //       isRelogin.show = false;
      //     });
      // }
      // store.dispatch("FedLogOut");
      // return res;
    } else if (
      code === 500 &&
      !apiList.includes(res.config.url.split("?")[0])
    ) {
      let showMsg = true;
      if (config.isSilence || config.isFocusPassCode) {
        showMsg = false;
      }
      showMsg &&
        Message({
          message: msg,
          type: "error",
        });
      return config.isFocusPassCode ? res.data : Promise.reject(new Error(msg));
    } else if (code !== 200) {
      // Notification.error({
      //   title: msg,
      // })
      if (!apiList.includes(res.config.url.split("?")[0])) {
        Message({
          message: msg,
          type: "error",
        });
      }
      // return Promise.reject('error')
      return res.data;
    } else {
      return res.data;
    }
  },
  (error) => {
    // 响应失败关闭loading
    clearTimeout(loadingTimer);
    if (loadingState) {
      loadingState = false;
      loadingInstance.close();
    }
    console.log("err: " + error);
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    if (message !== "数据正在处理，请勿重复提交") {
      Message({
        message: message,
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  },
  () => {}
);

const apiList = [
  //不需要显示loading的接口
  "/ouchn-customapi/web/read/updateOcDownloadReading",
  "/ouchn-customapi/getImagePathList?filePath=",
  "/ouchn-customapi/web/tbOrderAuthCard/selectCardBuCardNo",
  "/ouchn-customapi/device/paper/delWrongQuestion",
  "/ouchn-customapi/device/read/updateLexuePlayedbackSchedule",
  "/ouchn-customapi/device/paper/getNumberQuestionIsUse",
  "/ouchn-customapi/device/readerLog/addOrUpdate",
  "/ouchn-customapi/getSource",
];

export default service;
export { post, asyncPost, get, asyncGet };
